// ÇİÇEKLİ BİTKİLER PART 2 - bitkiVeritabani4.js
// Echinodorus devam + Vallisneria + Diğer Çiçekli Bitkiler (30 bitki)

export const cicekliBitkilerPart2 = [
  // ==================== ECHINODORUS (devam) ====================
  {
    id: 'echinodorus-x-barthii',
    isim: 'Barth Kılıcı',
    latince: 'Echinodorus x barthii',
    resim: '/images/bitkiler/echinodorus-x-barthii.jpg',
    kategori: 'Çiçekli Bitkiler',
    techSeviye: 'Mid Tech',
    habitat: 'Kültür formu',
    uzunluk: '25-50 cm',
    genislik: '25-40 cm',
    sicaklik: '22-28°C',
    ph: '6.5-7.5',
    sertlik: 'Yumuşak - Orta',
    isikIhtiyaci: 'Orta - Yüksek',
    co2Ihtiyaci: 'Önerilen',
    buyumeHizi: 'Orta',
    bakimZorlugu: 'Orta',
    konum: 'Arka plan',
    aciklama: 'Koyu kırmızı-kahverengi yapraklı hibrit tür.'
  },
  {
    id: 'echinodorus-red-diamond',
    isim: 'Kırmızı Elmas',
    latince: 'Echinodorus Red Diamond',
    resim: '/images/bitkiler/echinodorus-red-diamond.jpg',
    kategori: 'Çiçekli Bitkiler',
    techSeviye: 'Mid Tech',
    habitat: 'Kültür formu',
    uzunluk: '15-25 cm',
    genislik: '15-25 cm',
    sicaklik: '22-28°C',
    ph: '6.5-7.5',
    sertlik: 'Yumuşak - Orta',
    isikIhtiyaci: 'Orta - Yüksek',
    co2Ihtiyaci: 'Önerilen',
    buyumeHizi: 'Yavaş - Orta',
    bakimZorlugu: 'Orta',
    konum: 'Orta plan',
    aciklama: 'Kompakt boyutlu, koyu kırmızı yapraklı.'
  },
  {
    id: 'echinodorus-red-flame',
    isim: 'Kırmızı Alev',
    latince: 'Echinodorus Red Flame',
    resim: '/images/bitkiler/echinodorus-red-flame.jpg',
    kategori: 'Çiçekli Bitkiler',
    techSeviye: 'Mid Tech',
    habitat: 'Kültür formu',
    uzunluk: '20-35 cm',
    genislik: '20-30 cm',
    sicaklik: '22-28°C',
    ph: '6.5-7.5',
    sertlik: 'Yumuşak - Orta',
    isikIhtiyaci: 'Orta - Yüksek',
    co2Ihtiyaci: 'Önerilen',
    buyumeHizi: 'Orta',
    bakimZorlugu: 'Orta',
    konum: 'Orta plan',
    aciklama: 'Parlak kırmızı benekli yapraklar.'
  },
  {
    id: 'echinodorus-red-special',
    isim: 'Red Special',
    latince: 'Echinodorus Red Special',
    resim: '/images/bitkiler/echinodorus-red-special.jpg',
    kategori: 'Çiçekli Bitkiler',
    techSeviye: 'Mid Tech',
    habitat: 'Kültür formu',
    uzunluk: '20-40 cm',
    genislik: '20-35 cm',
    sicaklik: '22-28°C',
    ph: '6.5-7.5',
    sertlik: 'Yumuşak - Orta',
    isikIhtiyaci: 'Orta - Yüksek',
    co2Ihtiyaci: 'Önerilen',
    buyumeHizi: 'Orta',
    bakimZorlugu: 'Orta',
    konum: 'Orta - Arka plan',
    aciklama: 'Yoğun kırmızı renkli büyük yapraklar.'
  },
  {
    id: 'echinodorus-reni',
    isim: 'Reni Kılıcı',
    latince: 'Echinodorus Reni',
    resim: '/images/bitkiler/echinodorus-reni.jpg',
    kategori: 'Çiçekli Bitkiler',
    techSeviye: 'Mid Tech',
    habitat: 'Kültür formu',
    uzunluk: '15-30 cm',
    genislik: '15-25 cm',
    sicaklik: '22-28°C',
    ph: '6.5-7.5',
    sertlik: 'Yumuşak - Orta',
    isikIhtiyaci: 'Orta - Yüksek',
    co2Ihtiyaci: 'Önerilen',
    buyumeHizi: 'Yavaş - Orta',
    bakimZorlugu: 'Orta',
    konum: 'Orta plan',
    aciklama: 'Kompakt, koyu kırmızı-mor yapraklı.'
  },
  {
    id: 'echinodorus-kleiner-bar',
    isim: 'Küçük Ayı',
    latince: 'Echinodorus Kleiner Bär',
    resim: '/images/bitkiler/echinodorus-kleiner-bar.jpg',
    kategori: 'Çiçekli Bitkiler',
    techSeviye: 'Low Tech',
    habitat: 'Kültür formu',
    uzunluk: '10-20 cm',
    genislik: '10-20 cm',
    sicaklik: '22-28°C',
    ph: '6.5-7.5',
    sertlik: 'Yumuşak - Orta',
    isikIhtiyaci: 'Orta',
    co2Ihtiyaci: 'Opsiyonel',
    buyumeHizi: 'Yavaş - Orta',
    bakimZorlugu: 'Kolay',
    konum: 'Ön - Orta plan',
    aciklama: 'Küçük boyutlu, yeşil-kahverengi yapraklı.'
  },
  {
    id: 'echinodorus-aquartica',
    isim: 'Aquartica',
    latince: 'Echinodorus Aquartica',
    resim: '/images/bitkiler/echinodorus-aquartica.jpg',
    kategori: 'Çiçekli Bitkiler',
    techSeviye: 'Low Tech',
    habitat: 'Kültür formu',
    uzunluk: '10-20 cm',
    genislik: '15-25 cm',
    sicaklik: '22-28°C',
    ph: '6.5-7.5',
    sertlik: 'Yumuşak - Orta',
    isikIhtiyaci: 'Düşük - Orta',
    co2Ihtiyaci: 'Gerekli değil',
    buyumeHizi: 'Yavaş',
    bakimZorlugu: 'Kolay',
    konum: 'Ön - Orta plan',
    aciklama: 'Kompakt, geniş yapraklı cüce tür.'
  },
  {
    id: 'echinodorus-vesuvius',
    isim: 'Vezüv',
    latince: 'Echinodorus vesuvius',
    resim: '/images/bitkiler/echinodorus-vesuvius.jpg',
    kategori: 'Çiçekli Bitkiler',
    techSeviye: 'Low Tech',
    habitat: 'Kültür formu',
    uzunluk: '15-30 cm',
    genislik: '10-20 cm',
    sicaklik: '22-28°C',
    ph: '6.5-7.5',
    sertlik: 'Yumuşak - Orta',
    isikIhtiyaci: 'Orta',
    co2Ihtiyaci: 'Opsiyonel',
    buyumeHizi: 'Orta',
    bakimZorlugu: 'Kolay',
    konum: 'Orta plan',
    aciklama: 'Spiral şeklinde kıvrılan dar yapraklar.'
  },
  {
    id: 'echinodorus-quadricostatus',
    isim: 'Cüce Amazon',
    latince: 'Echinodorus quadricostatus',
    resim: '/images/bitkiler/echinodorus-quadricostatus.jpg',
    kategori: 'Çiçekli Bitkiler',
    techSeviye: 'Low Tech',
    habitat: 'Güney Amerika',
    uzunluk: '10-20 cm',
    genislik: '10-20 cm',
    sicaklik: '22-28°C',
    ph: '6.5-7.5',
    sertlik: 'Yumuşak - Orta',
    isikIhtiyaci: 'Orta',
    co2Ihtiyaci: 'Opsiyonel',
    buyumeHizi: 'Hızlı',
    bakimZorlugu: 'Kolay',
    konum: 'Ön - Orta plan',
    aciklama: 'Sürgünlerle hızlı yayılan cüce tür.'
  },
  {
    id: 'echinodorus-berteroi',
    isim: 'Berteroi Amazon',
    latince: 'Echinodorus berteroi',
    resim: '/images/bitkiler/echinodorus-berteroi.jpg',
    kategori: 'Çiçekli Bitkiler',
    techSeviye: 'Mid Tech',
    habitat: 'Kuzey Amerika',
    uzunluk: '20-40 cm',
    genislik: '20-35 cm',
    sicaklik: '20-26°C',
    ph: '6.5-7.5',
    sertlik: 'Yumuşak - Orta',
    isikIhtiyaci: 'Orta - Yüksek',
    co2Ihtiyaci: 'Önerilen',
    buyumeHizi: 'Orta',
    bakimZorlugu: 'Orta',
    konum: 'Orta - Arka plan',
    aciklama: 'Değişken yaprak formu gösteren ilginç tür.'
  },
  {
    id: 'echinodorus-macrophyllus',
    isim: 'Büyük Yapraklı Amazon',
    latince: 'Echinodorus macrophyllus',
    resim: '/images/bitkiler/echinodorus-macrophyllus.jpg',
    kategori: 'Çiçekli Bitkiler',
    techSeviye: 'Low Tech',
    habitat: 'Güney Amerika',
    uzunluk: '30-50 cm',
    genislik: '30-45 cm',
    sicaklik: '22-28°C',
    ph: '6.5-7.5',
    sertlik: 'Yumuşak - Orta',
    isikIhtiyaci: 'Orta',
    co2Ihtiyaci: 'Opsiyonel',
    buyumeHizi: 'Orta',
    bakimZorlugu: 'Kolay',
    konum: 'Arka plan',
    aciklama: 'Geniş oval yapraklı büyük tür.'
  },
  {
    id: 'echinodorus-palaefolius-latifolius',
    isim: 'Geniş Palae',
    latince: 'Echinodorus palaefolius var. latifolius',
    resim: '/images/bitkiler/echinodorus-palaefolius-latifolius.jpg',
    kategori: 'Çiçekli Bitkiler',
    techSeviye: 'Low Tech',
    habitat: 'Güney Amerika',
    uzunluk: '30-60 cm',
    genislik: '25-40 cm',
    sicaklik: '22-28°C',
    ph: '6.5-7.5',
    sertlik: 'Yumuşak - Orta',
    isikIhtiyaci: 'Orta',
    co2Ihtiyaci: 'Opsiyonel',
    buyumeHizi: 'Orta',
    bakimZorlugu: 'Kolay',
    konum: 'Arka plan',
    aciklama: 'Geniş yuvarlak yapraklı büyük bitki.'
  },
  {
    id: 'helanthium-tenellum',
    isim: 'Pigme Zincir Kılıç',
    latince: 'Helanthium tenellum',
    resim: '/images/bitkiler/helanthium-tenellum.jpg',
    kategori: 'Çiçekli Bitkiler',
    techSeviye: 'Mid Tech',
    habitat: 'Amerika',
    uzunluk: '5-15 cm',
    genislik: '5-15 cm',
    sicaklik: '20-28°C',
    ph: '6.0-7.5',
    sertlik: 'Yumuşak - Orta',
    isikIhtiyaci: 'Orta - Yüksek',
    co2Ihtiyaci: 'Önerilen',
    buyumeHizi: 'Orta - Hızlı',
    bakimZorlugu: 'Orta',
    konum: 'Ön plan',
    aciklama: 'Çim benzeri görünüm, sürgünlerle hızlı yayılır.'
  },
  {
    id: 'helanthium-bolivianum-angustifolius',
    isim: 'Dar Yapraklı Helanthium',
    latince: 'Helanthium bolivianum Angustifolius',
    resim: '/images/bitkiler/helanthium-bolivianum-angustifolius.jpg',
    kategori: 'Çiçekli Bitkiler',
    techSeviye: 'Mid Tech',
    habitat: 'Güney Amerika',
    uzunluk: '10-25 cm',
    genislik: '10-20 cm',
    sicaklik: '22-28°C',
    ph: '6.0-7.5',
    sertlik: 'Yumuşak - Orta',
    isikIhtiyaci: 'Orta - Yüksek',
    co2Ihtiyaci: 'Önerilen',
    buyumeHizi: 'Orta',
    bakimZorlugu: 'Orta',
    konum: 'Ön - Orta plan',
    aciklama: 'Dar uzun yapraklı kompakt tür.'
  },

  // ==================== VALLISNERIA (Saz Bitkileri) ====================
  {
    id: 'vallisneria-spiralis',
    isim: 'Saz Bitkisi',
    latince: 'Vallisneria spiralis',
    resim: '/images/bitkiler/vallisneria-spiralis.jpg',
    kategori: 'Çiçekli Bitkiler',
    techSeviye: 'Low Tech',
    habitat: 'Kozmopolit',
    uzunluk: '30-60 cm',
    genislik: '5-10 cm',
    sicaklik: '18-28°C',
    ph: '6.5-8.5',
    sertlik: 'Orta - Sert',
    isikIhtiyaci: 'Düşük - Orta',
    co2Ihtiyaci: 'Gerekli değil',
    buyumeHizi: 'Hızlı',
    bakimZorlugu: 'Çok kolay',
    konum: 'Arka plan',
    aciklama: 'En kolay bitkilerden biri. Sürgünlerle hızlı yayılır.'
  },
  {
    id: 'vallisneria-americana',
    isim: 'Amerikan Sazı',
    latince: 'Vallisneria americana',
    resim: '/images/bitkiler/vallisneria-americana.jpg',
    kategori: 'Çiçekli Bitkiler',
    techSeviye: 'Low Tech',
    habitat: 'Kuzey Amerika',
    uzunluk: '30-100 cm',
    genislik: '5-10 cm',
    sicaklik: '18-28°C',
    ph: '6.5-8.5',
    sertlik: 'Orta - Sert',
    isikIhtiyaci: 'Düşük - Orta',
    co2Ihtiyaci: 'Gerekli değil',
    buyumeHizi: 'Hızlı',
    bakimZorlugu: 'Çok kolay',
    konum: 'Arka plan',
    aciklama: 'Geniş yapraklı, uzun boylu dayanıklı tür.'
  },
  {
    id: 'vallisneria-australis',
    isim: 'Dev Saz',
    latince: 'Vallisneria australis',
    resim: '/images/bitkiler/vallisneria-australis.jpg',
    kategori: 'Çiçekli Bitkiler',
    techSeviye: 'Low Tech',
    habitat: 'Avustralya',
    uzunluk: '50-150 cm',
    genislik: '10-15 cm',
    sicaklik: '18-28°C',
    ph: '6.5-8.0',
    sertlik: 'Orta - Sert',
    isikIhtiyaci: 'Orta',
    co2Ihtiyaci: 'Gerekli değil',
    buyumeHizi: 'Hızlı',
    bakimZorlugu: 'Kolay',
    konum: 'Arka plan',
    aciklama: 'Çok uzun boylu, geniş yapraklı büyük tür.'
  },
  {
    id: 'vallisneria-nana',
    isim: 'Cüce Saz',
    latince: 'Vallisneria nana',
    resim: '/images/bitkiler/vallisneria-nana.jpg',
    kategori: 'Çiçekli Bitkiler',
    techSeviye: 'Low Tech',
    habitat: 'Avustralya',
    uzunluk: '15-40 cm',
    genislik: '5-10 cm',
    sicaklik: '20-28°C',
    ph: '6.5-8.0',
    sertlik: 'Yumuşak - Sert',
    isikIhtiyaci: 'Düşük - Orta',
    co2Ihtiyaci: 'Gerekli değil',
    buyumeHizi: 'Orta - Hızlı',
    bakimZorlugu: 'Kolay',
    konum: 'Orta - Arka plan',
    aciklama: 'Dar ve kısa yapraklı kompakt tür.'
  },
  {
    id: 'vallisneria-asiatica',
    isim: 'Asya Sazı',
    latince: 'Vallisneria asiatica',
    resim: '/images/bitkiler/vallisneria-asiatica.jpg',
    kategori: 'Çiçekli Bitkiler',
    techSeviye: 'Low Tech',
    habitat: 'Asya',
    uzunluk: '30-60 cm',
    genislik: '5-10 cm',
    sicaklik: '20-28°C',
    ph: '6.5-8.0',
    sertlik: 'Yumuşak - Sert',
    isikIhtiyaci: 'Düşük - Orta',
    co2Ihtiyaci: 'Gerekli değil',
    buyumeHizi: 'Hızlı',
    bakimZorlugu: 'Kolay',
    konum: 'Arka plan',
    aciklama: 'Kıvrımlı yapraklı dekoratif tür.'
  },
  {
    id: 'vallisneria-asiatica-biwaensis',
    isim: 'Biwa Sazı',
    latince: 'Vallisneria asiatica var. Biwaensis',
    resim: '/images/bitkiler/vallisneria-asiatica-biwaensis.jpg',
    kategori: 'Çiçekli Bitkiler',
    techSeviye: 'Low Tech',
    habitat: 'Japonya',
    uzunluk: '30-50 cm',
    genislik: '5-8 cm',
    sicaklik: '18-26°C',
    ph: '6.5-8.0',
    sertlik: 'Yumuşak - Sert',
    isikIhtiyaci: 'Düşük - Orta',
    co2Ihtiyaci: 'Gerekli değil',
    buyumeHizi: 'Orta - Hızlı',
    bakimZorlugu: 'Kolay',
    konum: 'Arka plan',
    aciklama: 'Serin suyu seven, spiral yapraklı.'
  },
  {
    id: 'vallisneria-torta',
    isim: 'Burgu Saz',
    latince: 'Vallisneria torta',
    resim: '/images/bitkiler/vallisneria-torta.jpg',
    kategori: 'Çiçekli Bitkiler',
    techSeviye: 'Low Tech',
    habitat: 'Asya',
    uzunluk: '20-40 cm',
    genislik: '5-10 cm',
    sicaklik: '20-28°C',
    ph: '6.5-8.0',
    sertlik: 'Yumuşak - Sert',
    isikIhtiyaci: 'Düşük - Orta',
    co2Ihtiyaci: 'Gerekli değil',
    buyumeHizi: 'Orta - Hızlı',
    bakimZorlugu: 'Kolay',
    konum: 'Orta - Arka plan',
    aciklama: 'Güçlü spiral yapraklı dekoratif tür.'
  },
  {
    id: 'vallisneria-sp-mini-twister',
    isim: 'Mini Burgu Saz',
    latince: 'Vallisneria sp. Mini Twister',
    resim: '/images/bitkiler/vallisneria-sp-mini-twister.jpg',
    kategori: 'Çiçekli Bitkiler',
    techSeviye: 'Low Tech',
    habitat: 'Kültür formu',
    uzunluk: '15-30 cm',
    genislik: '5-10 cm',
    sicaklik: '20-28°C',
    ph: '6.5-8.0',
    sertlik: 'Yumuşak - Sert',
    isikIhtiyaci: 'Düşük - Orta',
    co2Ihtiyaci: 'Gerekli değil',
    buyumeHizi: 'Orta',
    bakimZorlugu: 'Kolay',
    konum: 'Orta plan',
    aciklama: 'Kompakt boyutlu, spiral yapraklı.'
  },

  // ==================== DİĞER ÇİÇEKLİ BİTKİLER ====================
  {
    id: 'sagittaria-subulata',
    isim: 'Cüce Ok Bitkisi',
    latince: 'Sagittaria subulata',
    resim: '/images/bitkiler/sagittaria-subulata.jpg',
    kategori: 'Çiçekli Bitkiler',
    techSeviye: 'Low Tech',
    habitat: 'Amerika',
    uzunluk: '10-30 cm',
    genislik: '5-15 cm',
    sicaklik: '18-28°C',
    ph: '6.0-8.0',
    sertlik: 'Yumuşak - Sert',
    isikIhtiyaci: 'Düşük - Orta',
    co2Ihtiyaci: 'Gerekli değil',
    buyumeHizi: 'Hızlı',
    bakimZorlugu: 'Çok kolay',
    konum: 'Ön - Orta plan',
    aciklama: 'Çim benzeri, sürgünlerle hızlı yayılır. Çok dayanıklı.'
  },
  {
    id: 'sagittaria-platyphylla',
    isim: 'Geniş Yapraklı Ok',
    latince: 'Sagittaria platyphylla',
    resim: '/images/bitkiler/sagittaria-platyphylla.jpg',
    kategori: 'Çiçekli Bitkiler',
    techSeviye: 'Low Tech',
    habitat: 'Kuzey Amerika',
    uzunluk: '15-30 cm',
    genislik: '10-20 cm',
    sicaklik: '18-26°C',
    ph: '6.5-7.5',
    sertlik: 'Yumuşak - Orta',
    isikIhtiyaci: 'Orta',
    co2Ihtiyaci: 'Opsiyonel',
    buyumeHizi: 'Orta',
    bakimZorlugu: 'Kolay',
    konum: 'Orta plan',
    aciklama: 'Geniş oval yapraklı Sagittaria türü.'
  },
  {
    id: 'blyxa-japonica',
    isim: 'Japon Blyxa',
    latince: 'Blyxa japonica',
    resim: '/images/bitkiler/blyxa-japonica.jpg',
    kategori: 'Çiçekli Bitkiler',
    techSeviye: 'Mid Tech',
    habitat: 'Doğu Asya',
    uzunluk: '7-15 cm',
    genislik: '5-10 cm',
    sicaklik: '22-28°C',
    ph: '5.5-7.0',
    sertlik: 'Yumuşak',
    isikIhtiyaci: 'Orta - Yüksek',
    co2Ihtiyaci: 'Önerilen',
    buyumeHizi: 'Orta',
    bakimZorlugu: 'Orta',
    konum: 'Ön - Orta plan',
    aciklama: 'Zarif çim benzeri görünüm. Aquascape favorisi.'
  },
  {
    id: 'blyxa-aubertii',
    isim: 'Aubertii Blyxa',
    latince: 'Blyxa aubertii',
    resim: '/images/bitkiler/blyxa-aubertii.jpg',
    kategori: 'Çiçekli Bitkiler',
    techSeviye: 'Mid Tech',
    habitat: 'Asya, Afrika',
    uzunluk: '15-40 cm',
    genislik: '5-10 cm',
    sicaklik: '22-28°C',
    ph: '6.0-7.5',
    sertlik: 'Yumuşak - Orta',
    isikIhtiyaci: 'Orta - Yüksek',
    co2Ihtiyaci: 'Önerilen',
    buyumeHizi: 'Orta',
    bakimZorlugu: 'Orta',
    konum: 'Orta plan',
    aciklama: 'B. japonica\'dan daha uzun, zarif görünüm.'
  },
  {
    id: 'cyperus-helferi',
    isim: 'Cyperus',
    latince: 'Cyperus helferi',
    resim: '/images/bitkiler/cyperus-helferi.jpg',
    kategori: 'Çiçekli Bitkiler',
    techSeviye: 'Mid Tech',
    habitat: 'Tayland',
    uzunluk: '20-40 cm',
    genislik: '15-25 cm',
    sicaklik: '22-28°C',
    ph: '6.0-7.5',
    sertlik: 'Yumuşak - Orta',
    isikIhtiyaci: 'Orta - Yüksek',
    co2Ihtiyaci: 'Önerilen',
    buyumeHizi: 'Yavaş - Orta',
    bakimZorlugu: 'Orta',
    konum: 'Orta - Arka plan',
    aciklama: 'Çimen benzeri uzun dar yapraklar. Benzersiz görünüm.'
  },
  {
    id: 'samolus-valerandi',
    isim: 'Su Çuha Çiçeği',
    latince: 'Samolus valerandi',
    resim: '/images/bitkiler/samolus-valerandi.jpg',
    kategori: 'Çiçekli Bitkiler',
    techSeviye: 'Mid Tech',
    habitat: 'Kozmopolit',
    uzunluk: '5-15 cm',
    genislik: '5-10 cm',
    sicaklik: '15-24°C',
    ph: '6.5-8.0',
    sertlik: 'Orta - Sert',
    isikIhtiyaci: 'Orta - Yüksek',
    co2Ihtiyaci: 'Önerilen',
    buyumeHizi: 'Yavaş',
    bakimZorlugu: 'Orta',
    konum: 'Ön plan',
    aciklama: 'Rozet formlu, serin su seven nadir tür.'
  }
];

export default cicekliBitkilerPart2;